import { Box, Button, Heading, Text, useStyleConfig } from '@chakra-ui/react';
import ProTip from '../formElements/components/ProTip';
import { FaDownload } from 'react-icons/fa';
import { onDownload, onDownloadCoverLetter } from '../handlers';
import React from 'react';
import { getUsefulVars } from '../handlers/helpers';
import { parseCoverLetter } from './Parser/utils';


const SectionHeader = ({ navSection,props }) => {
  const uv = getUsefulVars(props);
  const sectionName = uv.stateProps.sectionData.sectionName;
  const variant = 'wrapper';
  const buttonStyles = useStyleConfig('Button', { variant });
  const height = sectionName === 'job-posting' ? '5rem' : 'auto';
  const label =
    typeof navSection.alias === 'undefined'
      ? navSection.label
      : navSection.alias;

  return (
    <Box paddingBottom="16px" position='relative' height={height}>
      <ProTip proTip={navSection.instructions} variant='section' stateProps={uv.stateProps} />

      <Heading variant="sectionHeading">{label}</Heading>
      <Text variant="sectionText">{navSection.tagline}</Text>
    </Box>
  );
};

export default SectionHeader;
